import { render, staticRenderFns } from "./CustomerLogs.vue?vue&type=template&id=9937c394"
import script from "./CustomerLogs.vue?vue&type=script&lang=ts"
export * from "./CustomerLogs.vue?vue&type=script&lang=ts"
import style0 from "./CustomerLogs.vue?vue&type=style&index=0&id=9937c394&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports